











import Vue from 'vue';
import { mapState, mapGetters, mapMutations } from 'vuex';
import FilterBlock from "../components/FilterBlock.vue";
import FilteredList from "../components/FilteredList.vue";


export default Vue.extend({
  name: 'PenthouseList',
  components: {
    FilterBlock,
    FilteredList
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapState(['penthousesList', 'windowWidth', 'filterIsOpened', 'statusesAndPrices']),
    ...mapGetters(['penthousesFilteredAndSorted']),
    isSmall() {
      return this.windowWidth < 1200;
    }
  },
  beforeCreate() {
    this.$store.dispatch('getPenthousesList');
    this.$store.dispatch('getStatusesAndPrices')
    document.body.classList.add('_white-bg');
  },
  mounted() {
    document.body.classList.add('__penthouse-selection')
    console.log(this.penthousesFilteredAndSorted, '------------')

  },
  watch: {
    $route(to,from) {
      this.$store.dispatch('updateFilters', this.$route.query)
    }
  },
  methods: {
    ...mapMutations(['openFilter'])
  }
});
